import { create } from 'zustand'

interface IChangeValueLoginStore {
    value: number
    setValue: (value: number) => void
}

export const useChangeValueLoginStore = create<IChangeValueLoginStore>((set,get) => ({
    value: 0,
    setValue: () => {
        set({ value: get().value + 1 })
    }
}))